// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import './assets/tailwind.css'; // Import Tailwind CSS
import store from './store';  // Vuex store (if used)
import router from './router';  // Corrected router import
import PrimeVue from "primevue/config";

// import "primevue/resources/themes/md-light-indigo/theme.css";
// import "primevue/resources/primevue.min.css";
createApp(App).use(router).use(PrimeVue).use(store).mount('#app');
